import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  SHIFT_REQUEST,
  SHIFT_FAILURE,
  SHIFT_SUCCESS,
  ShiftActionType,
} from '../types/shiftType';
import { ShiftOpen, ShiftClose } from 'src/types/model';
import { toastAlert } from 'src/utils/toastAlert';

export const shiftRequest = (): ShiftActionType => ({
  type: SHIFT_REQUEST,
});

export const shiftSuccess = (data: boolean): ShiftActionType => ({
  type: SHIFT_SUCCESS,
  payload: data,
});

export const shiftFailure = (error: string): ShiftActionType => ({
  type: SHIFT_FAILURE,
  payload: error,
});

export const checkShift = () => {
  return async (dispatch: Dispatch<ShiftActionType>) => {
    dispatch(shiftRequest());
    try {
      const request = await Service.get('/shifts/info');
      const data = request?.data?.data?.isShiftOpen;
      dispatch(shiftSuccess(data));
    } catch (error: any) {
      dispatch(shiftFailure(error?.message));
      toastAlert('error', error?.message);
      throw new Error('Failed to fetch shift');
    }
  };
};

export const openShift = (val: ShiftOpen) => {
  return async (dispatch: Dispatch<ShiftActionType>) => {
    dispatch(shiftRequest());
    try {
      const request: any = await Service.post('/shifts/create', val);
      const data = request?.data?.success;
      toastAlert('success', 'Shift opened successfully');
      dispatch(shiftSuccess(data));
    } catch (error: any) {
      dispatch(shiftFailure(error?.message));
      toastAlert('error', error?.message);
      throw new Error('Failed to fetch shift');
    }
  };
};

export const closeShift = (val: ShiftClose) => {
  return async (dispatch: Dispatch<ShiftActionType>) => {
    dispatch(shiftRequest());
    try {
      const request: any = await Service.post('/shifts/end', val);
      const data = request?.data?.success;
      toastAlert('success', 'Shift closed successfully');
      dispatch(shiftSuccess(!data));
    } catch (error: any) {
      dispatch(shiftFailure(error?.message));
      toastAlert('error', error?.message);
      throw new Error('Failed to fetch shift');
    }
  };
};
